import { App } from 'vue';
import { useAppStore } from './appStore';
import { createGtm, VueGtmUseOptions } from 'vue-gtm';
import { isEmpty } from 'lodash-es';
import { VueReCaptcha } from 'vue-recaptcha-v3-esm';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

type SetupAppOptions = {
    kolumbusWebsiteBaseUrl: string;
    googleTagManagerOptions?: VueGtmUseOptions;
    googleRecaptcha?: { siteKey?: string };
    azureMonitor?: {
        azureMonitorConnectionString?: string;
        azureMonitorClientSideTrackingEnabled?: boolean;
    };
};

export function setupApp(options: SetupAppOptions) {
    return {
        install: (app: App) => {
            const appStore = useAppStore();

            // init app store
            appStore.init({ kolumbusWebsiteBaseUrl: options.kolumbusWebsiteBaseUrl });

            // setup google tag manager
            if (!isEmpty(options.googleTagManagerOptions) && options.googleTagManagerOptions.id) {
                console.info('Setting up Google Tag Manager', options.googleTagManagerOptions);
                app.use(createGtm(options.googleTagManagerOptions));
            }

            // setup reCaptcha
            if (!isEmpty(options.googleRecaptcha) && options.googleRecaptcha.siteKey) {
                console.info('Setting up reCaptcha', options.googleRecaptcha);
                app.use(VueReCaptcha, {
                    siteKey: options.googleRecaptcha.siteKey,
                    loaderOptions: { autoHideBadge: true }
                });
            }

            // setup azure monitor
            if (
                !isEmpty(options.azureMonitor) &&
                options.azureMonitor.azureMonitorConnectionString &&
                options.azureMonitor.azureMonitorClientSideTrackingEnabled
            ) {
                console.info('Setting up Azure Monitor', options.azureMonitor);
                const appInsights = new ApplicationInsights({
                    config: {
                        connectionString: options.azureMonitor.azureMonitorConnectionString,
                        enableAutoRouteTracking: true
                    }
                });
                appInsights.loadAppInsights();
            }
        }
    };
}
